export const TRANSACTION_REPORT_TABS = {
    REPORT: 1,
    GENERATED: 2,
};

export const GENERATED_REPORTS_PAGE_SIZE = 20;
